import { render, staticRenderFns } from "./TaskActivityItem.vue?vue&type=template&id=f27d3c98&"
import script from "./TaskActivityItem.vue?vue&type=script&lang=js&"
export * from "./TaskActivityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports